let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fjjOl")).then(() => parcelRequire('6l95m'));